/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-08-02 11:46:43
 * @LastEditors: linxi
 * @LastEditTime: 2023-08-03 15:42:26
 */
import { createAsyncThunk } from '@reduxjs/toolkit'
import { sendAsync } from '../../app/applicationSlice'
import { RootThunkApi } from '../../app/store'
import { getPriceSetFn, getPriceSetFnParams } from '../../services/priceSet'
import * as ST from '../../services/tenant'


//  代煎饮片厂列表
export const getPriceSet = createAsyncThunk<
  any,
  getPriceSetFnParams,
  RootThunkApi
>('stand/getPriceSet', async (params, api) => {
  return sendAsync(getPriceSetFn(params), api)
})


// 续订价格列表列表
export const getPriceList = createAsyncThunk<
  void,
  ST.getOrderListFnParams,
  RootThunkApi
>('ProvinceList/getPriceList', async (params, api) => {
  return sendAsync(ST.getPriceListFn(params), api)
})


// 续订价格列表详情
export const getPriceDetail = createAsyncThunk<
  void,
  any,
  RootThunkApi
>('ProvinceList/getPriceDetail', async (params, api) => {
  return sendAsync(ST.priceDetail(params), api)
})

export const getPriceDetailSubmit = createAsyncThunk<
  void,
  ST.priceDetailSubmitParams,
  RootThunkApi
>('ProvinceList/getPriceDetailSubmit', async (params, api) => {
  return sendAsync(ST.priceDetailSubmit(params), api)
})


